import { render, staticRenderFns } from "./MarvinInfoBox.vue?vue&type=template&id=4f5a7747&scoped=true"
import script from "./MarvinInfoBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarvinInfoBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MarvinInfoBox.vue?vue&type=style&index=0&id=4f5a7747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a7747",
  null
  
)

export default component.exports